import React from 'react';
import { Row, Col, Badge} from 'reactstrap';
import i18n from "i18next";
import ModeItemExercise from "./ModeItemExercise";
import "../../style/ModeItem.sass"
import {useNavigate} from "react-router-dom";

function ModeItem({mode, onClick, modeKey, showExercise, showBackButton}){
    const navigate = useNavigate()
    const localOnClick = () => {
        console.log(mode, onClick, modeKey, showExercise, showBackButton)
        if(!onClick){
            return;
        }
        onClick(modeKey);
    };

    const getBadges = (mode) => {
        let badges = mode.getBadges();
        const badgeElements = [];
        badges.forEach((badge)=>{
            badgeElements.push(<Badge key={"mode-item-badge-"+badge}>{i18n.t(badge)}</Badge>)
        });
        mode.getBitCount().forEach((bitCount, index)=>{
            badgeElements.push(<Badge key={"mode-item-badge-"+index}>
                {`${bitCount} ${i18n.t("bit")}`}
            </Badge>)
        });
        return badgeElements;
    };

    const back = () => {
        navigate(-1)
    }

    const badges = getBadges(mode);
    let titleClassNames = "";

    let exerciseItem = <div/>;
    if(showExercise){
        exerciseItem = <ModeItemExercise
            mode={mode}
        />;
    }

    let backButton = undefined
    if(showBackButton) backButton = <span className={"mode-card-title-block"} onClick={back}>
                        <i className="material-icons">arrow_back</i>
                    </span>

    return <Row onClick={localOnClick}>
        <Col xs={12} className={`${titleClassNames} mode-card-title`}>
            <div className={"mode-card-title-col"}>
                {backButton}
                <span className={"mode-card-title-text"}>{i18n.t(modeKey, {})}</span>
                <span className={"mode-card-title-block"}></span>
            </div>
            <div className={"mode-card-title"}>
                {exerciseItem}
            </div>
            <div className={"mode-card-badges"}>
                {badges}
            </div>
        </Col>
    </Row>
}
export default ModeItem